import { Modal } from "tailwindcss-stimulus-components";

export default class MissionTaskTrackingModal extends Modal {
  static targets = ["dialog", "frame"];
  static values = { missionId: String }

  connect() {
    super.connect();
    this.handleEscapeBound = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close(event);
      }
    };
    if (this.hasDialogTarget) {
      this.dialogTarget.addEventListener('keydown', this.handleEscapeBound);
    }
  }

  disconnect() {
    if (this.hasDialogTarget) {
      this.dialogTarget.removeEventListener('keydown', this.handleEscapeBound);
    }
    super.disconnect();
  }

  open(event) {
    // Extract IDs from the clicked button BEFORE opening the dialog
    const taskId = this.getTaskIdFromEvent(event);
    const missionId = this.getMissionIdFromEvent(event);

    // Update missionId if provided from button (for all mission tasks context)
    if (missionId) {
      this.missionIdValue = missionId;
    }

    // Reset frame to force fresh load for the new task
    if (this.hasFrameTarget) {
      this.resetFrame();
    }

    super.open(event);

    if (taskId) {
      this.loadContent(taskId);
    }

    if (this.hasDialogTarget) {
      this.dialogTarget.focus();
    }
  }

  getTaskIdFromEvent(event) {
    if (!event?.target) return null;
    const button = event.target.closest('[data-mission-task-tracking-modal-task-id-value]');
    return button ? button.dataset.missionTaskTrackingModalTaskIdValue : null;
  }

  getMissionIdFromEvent(event) {
    if (!event?.target) return null;
    const button = event.target.closest('[data-mission-task-tracking-modal-mission-id-value]');
    return button ? button.dataset.missionTaskTrackingModalMissionIdValue : null;
  }

  close(event) {
    event?.preventDefault();
    super.close(event);
  }

  resetFrame() {
    this.frameTarget.removeAttribute('src');
    this.frameTarget.removeAttribute('complete');
    this.frameTarget.removeAttribute('loading');
    this.frameTarget.innerHTML = this.loadingSpinnerHTML();
  }

  loadingSpinnerHTML() {
    return `<div class="p-8 flex items-center justify-center">
      <div class="flex flex-col items-center">
        <svg class="animate-spin h-8 w-8 text-blue-600 mb-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <p class="text-sm text-gray-500">Loading tracking settings...</p>
      </div>
    </div>`;
  }

  loadContent(taskId) {
    if (this.hasFrameTarget && taskId) {
      let url;
      if (this.hasMissionIdValue && this.missionIdValue) {
        url = `/missions/${this.missionIdValue}/tasks/${taskId}/tracking_settings`;
      } else {
        url = `/all_mission_tasks/${taskId}/tracking_settings`;
      }
      this.frameTarget.setAttribute('src', url);
    }
  }
}
